//import { ethers } from "ethers";
//import { useStaticQuery, graphql } from "gatsby";

import assetPairData from '../../../static/data/assetPairs.json';
const randNumRange = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

let assetPairs = [];

assetPairData.pairs.forEach(pair => {
    let assetsList = [];
    assetPairData.assets.forEach(asset => {
        if (pair.assets.includes(asset.symble)) {
            assetsList.push(asset);
        }
    });
    assetPairs.push({
        ...pair,
        chartDataPoints: [],
        assets: [...assetsList]
    });
});

export const SET_ASSET_PAIR = 'trade/set_asset_pair';

const generateDataPoints = (noOfDps) => {
    const CANDLE_POINTS = 10;
    let cpcount = 0;
    var yVal = 1000;
    var dps = [];
    let date = new Date("2017-01-01");
    for (var i = 0; i < noOfDps; i++) {
        if (cpcount >= CANDLE_POINTS) {
            cpcount = 0;
            const tm = date.getTime();
            date = new Date(tm + (3600000 * 5));
        }
        yVal = yVal + Math.round(50 + Math.random() * (-50 - 50));
        //let x = String(i/60)+String(i%60).padStart(4, '0');
        dps.push({ dt: date.getTime() / 1000, x: i, y: yVal });
        cpcount++;
    }
    return dps;
}

const generateOrderBook = (noOfDps) => {
    let dps = [];
    for (var i = 0; i < noOfDps; i++) {
        const marketSize = 500 + Math.round(50 + Math.random() * (-250 - 250));
        const price = 9.0000 + Math.round(50 + Math.random() * (-50 - 50));
        dps.push({ marketSize, price, mySize: 0 })
    }
    return dps;
}


/*
const assetPairs = queryData.allAssetPair.nodes.map((pair, index) => {
    return {
        index,
        ...pair,
        chartDataPoints: []
    };
});
*/
const generateOrders = (noOfDps) => {
    let dps = [];
    for (var i = 0; i < noOfDps; i++) {
        const side = randNumRange(0, 1);
        const size = randNumRange(10, 250);
        const lfill = randNumRange(8, 15);
        const rfill = randNumRange(10, 30);
        const fee = randNumRange(0.5, 6.0);
        const stat = randNumRange(0, 1);
        dps.push({ side, size, lfill, rfill, fee, stat, time: i });
    }
    return dps;
}

const generateTradeHistory = (noOfDps) => {
        let dps = [];
        for (var i = 0; i < noOfDps; i++) {
            const tradeSize = 500 + Math.round(50 + Math.random() * (-250 - 250));
            const price = 9.0000 + Math.round(50 + Math.random() * (-50 - 50));
            const orderType = randNumRange(0, 1);
            dps.push({ orderType, tradeSize, price, time: 1 })
        }
        return dps;
    }
    /*
    const tempData = {
        openOrders: [{
            pair: 'USDT - ETH',
            type: 'sell',
            price: 104988,
            amount: 1000
        }],
        orderHistory: [{
            pair: 'USDT - ETH',
            type: 'buy',
            price: 100050,
            amount: 1000
        }]
    };
    
const myOrders = {
    open: generateOrders(3),
    filled: generateOrders(20)
}
*/
const initialState = {
    assetPairs,
    selectedAssetPair: 0,
    tradeOrderData: {
        open: generateOrders(3),
        filled: generateOrders(20)
    },
    tradeHistory: generateTradeHistory(1000),
    orderBooks: {
        sell: generateOrderBook(100),
        buy: generateOrderBook(100)
    },
    error: ''
};

export default function tradeReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ASSET_PAIR:
            const assetPiair = state.assetPairs[action.assetPairIndex];
            if (assetPiair.chartDataPoints.length === 0) {
                let myAssetPairs = state.assetPairs;
                myAssetPairs[action.assetPairIndex].chartDataPoints = generateDataPoints(1000);
                return {...state, selectedAssetPair: action.assetPairIndex, assetPairs: myAssetPairs };
            }
            return {...state, selectedAssetPair: action.assetPairIndex };
        default:
            return state;
    }
}

export const SetAssetPair = (dispatch, key) => {
    const assetPairIndex = assetPairData.pairs.findIndex(a => a.key === key);
    return dispatch({ type: SET_ASSET_PAIR, assetPairIndex });
};